import ApiService from '@/services/ApiService'

const getPayload = (files, documentId, personId, documentKind) => {
  const payLoad = new FormData()

  files.forEach((file) => {
    payLoad.append('supporting_documents[pages][]', file)
  })

  if (documentId) {
    payLoad.set('id', documentId)
  } else {
    payLoad.append('supporting_documents[person]', personId)
    payLoad.append('supporting_documents[document_kind]', documentKind)
  }

  return payLoad
}

const deleteDocument = async (documentId) => {
  return await ApiService.deleteDocument(documentId)
}

const deleteFiles = async (documentId, deletedFilesIds) => {
  if (deletedFilesIds.length === 0) {
    return
  }
  await ApiService.deletePage(documentId, deletedFilesIds)
}

const uploadFiles = async ($t, files, documentId, personId, documentKind) => {
  if (files.length === 0) {
    return
  }
  const payload = getPayload(files, documentId, personId, documentKind)

  const result = documentId ? await ApiService.addPages(payload) : await ApiService.createDocument(payload)
  if (!result || !result.data || !result.data.attributes || result.data.attributes.status !== 'uploaded') {
    throw new Error('file_upload_error')
  }
}

export {
  deleteDocument, uploadFiles, deleteFiles 
}
